import React from "react";
import {
  Card,
  CardBody,
  CardHeader,
  Col,
  Badge,
} from "reactstrap";

const MappingStatus = ({
  mappings,
}) => {

  const mappingList =
    Array.isArray(mappings)
      ? mappings
      : Array.isArray(
          mappings?.data
        )
      ? mappings.data
      : [];

  const totalMappings =
    mappingList.length;

  const syncedMappings =
    mappingList.filter(
      m =>
        m.syncStatus ===
        "Synced"
    ).length;

  const pendingMappings =
    mappingList.filter(
      m =>
        m.syncStatus ===
        "Pending"
    ).length;

  const failedMappings =
    totalMappings -
    syncedMappings -
    pendingMappings;

  return (
    <Col xl={4}>
      <Card
        style={{
          height: "100%",
        }}
      >
        <CardHeader>
          <div className="d-flex justify-content-between align-items-center">
            <h4 className="card-title mb-0">
              Room Mapping Status
            </h4>

            <Badge color="primary">
              {totalMappings}
            </Badge>
          </div>
        </CardHeader>

        <CardBody>

          {/* Summary */}

          <div className="mb-4">

            <div className="d-flex justify-content-between mb-2">
              <span>
                Total Mappings
              </span>

              <strong>
                {totalMappings}
              </strong>
            </div>

            <div className="d-flex justify-content-between mb-2">
              <span>
                Synced
              </span>

              <Badge color="success">
                {syncedMappings}
              </Badge>
            </div>

            <div className="d-flex justify-content-between mb-2">
              <span>
                Pending
              </span>

              <Badge color="warning">
                {pendingMappings}
              </Badge>
            </div>

            <div className="d-flex justify-content-between">
              <span>
                Failed
              </span>

              <Badge color="danger">
                {failedMappings}
              </Badge>
            </div>

          </div>

          <hr />

          {/* Mapping List */}

          {mappingList.length === 0 ? (
            <div className="text-center text-muted py-4">
              No Room Mappings Found
            </div>
          ) : (
            mappingList
              .slice(0, 10)
              .map(mapping => (
                <div
                  key={
                    mapping._id
                  }
                  className="d-flex justify-content-between align-items-center mb-3"
                >
                  <div>
                    <div className="fw-semibold">
                      {
                        mapping.pmsRoomTypeName
                      }
                    </div>

                    <small className="text-muted">
                      {
                        mapping.channelManager
                      }
                    </small>
                  </div>

                  <Badge
                    color={
                      mapping.syncStatus ===
                      "Synced"
                        ? "success"
                        : mapping.syncStatus ===
                          "Pending"
                        ? "warning"
                        : "danger"
                    }
                  >
                    {
                      mapping.syncStatus ||
                      "Unknown"
                    }
                  </Badge>
                </div>
              ))
          )}

        </CardBody>
      </Card>
    </Col>
  );
};

export default MappingStatus;